import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.PersonsOneStep.PersonsTable', {
    name: 'Name',
    role: 'Role',
    director: 'Director',
    ultimateBusinessOwner: 'Owner',
    ready: 'Ready',
    notReady: 'Not ready',
});
